import { GameModal } from "../GameModal";

export function RedPacketResultModal({
  open,
  selectedIndex,
  variant = "newbie-step6",
  title,
  message,
  amount,
  tone = "info",
  primaryText = "知道了",
  onClose
}: {
  open: boolean;
  selectedIndex: number | null;
  variant?: "newbie-step6" | "standard";
  title: string;
  message: string;
  amount?: number | null;
  tone?: "info" | "reward" | "error";
  primaryText?: string;
  onClose: () => void;
}) {
  return (
    <GameModal
      open={open}
      title={title}
      primaryText={primaryText}
      tone={tone}
      onClose={onClose}
      onPrimary={onClose}
    >
      <div className="rg-redpacket-result" data-variant={variant}>
        {selectedIndex !== null ? <p>你剛剛選擇了第 {selectedIndex + 1} 個紅包。</p> : null}
        {typeof amount === "number" ? <strong>恭喜抽中 {amount.toLocaleString("zh-TW")} 點</strong> : null}
        <p>{message}</p>
        <p>正式中獎金額由系統抽獎決定，選哪個紅包不會影響中獎機率。</p>
      </div>
    </GameModal>
  );
}
